module.exports = __webpack_public_path__ + "images/emoji/calling.d3d9b0b7eebc3aaf0fdf.png";